import HotelRoomImages from './HotelRoomImages.component';
export default HotelRoomImages;